import Vue from 'vue';
import Router, { RouteConfig } from 'vue-router';

Vue.use(Router);

const routes: RouteConfig[] = [
  /*********** Lists ***************/
  // Users List
  {
    path: '/',
    name: 'users',
    component: () => import('./views/Users.vue'),
  },
  // Projects List
  {
    path: '/projects',
    name: 'projects',
    component: () => import('./views/Projects.vue'),
    meta: { requiredRoles: ['project_manager', 'project_owner'] },
  },
  // Customer List
  {
    path: '/customers',
    name: 'customers',
    component: () => import('./views/Customers.vue'),
    meta: { requiredRoles: ['project_owner'] },
  },
  // My Logworks
  {
    path: '/my_logworks',
    name: 'my_logworks',
    component: () => import('./views/MyLogworks.vue'),
  },
  {
    path: '/user_logworks/:user_id',
    name: 'user_logworks',
    component: () => import('./views/UserLogworks.vue'),
  },
  /*****************************/
  // Project
  {
    path: '/projects/:project_id',
    component: () => import('./views/project/Project.vue'),
    meta: { requiredRoles: ['project_manager', 'project_owner'] },
    children: [
      // Issue List
      {
        path: 'issue_list',
        name: 'issue_list',
        component: () => import('./views/project/IssueList.vue'),
      },
      // Active Sprints
      {
        path: 'active_sprints',
        name: 'active_sprints',
        component: () => import('./views/project/ActiveSprints.vue'),
      },
      // Epics Sprints
      {
        path: 'epics',
        name: 'epics',
        component: () => import('./views/project/Epics.vue'),
      },
      // Start sprint
      {
        path: 'start_sprint',
        name: 'start_sprint',
        component: () => import('./views/project/StartSprint.vue'),
      },
    ],
  },
  // Issues
  {
    path: '/issues',
    component: () => import('./views/issues/Issues.vue'),
    children: [
      // Actual Issues
      {
        path: 'actual',
        name: 'actual_issues',
        component: () => import('./views/issues/ActualIssues.vue'),
      },
      // Done Issues
      {
        path: 'done',
        name: 'done_issues',
        component: () => import('./views/issues/DoneIssues.vue'),
      },
    ],
  },
  /********** Editors ************/
  // Project Editor
  {
    path: '/project/edit',
    name: 'project_editor',
    component: () => import('./views/editors/ProjectEditor.vue'),
    meta: { requiredRoles: ['project_owner'] },
  },
  // Customer Editor
  {
    path: '/customer/edit',
    name: 'customer_editor',
    component: () => import('./views/editors/CustomerEditor.vue'),
    meta: { requiredRoles: ['project_owner'] },
  },
  // Issue Editor
  {
    path: '/issue/edit',
    name: 'issue_editor',
    component: () => import('./views/editors/IssueEditor.vue'),
  },
  // Logwork Editor
  {
    path: '/issues/:issue_id/logwork/edit',
    name: 'logwork_editor',
    component: () => import('./views/editors/LogworkEditor.vue'),
  },
  // Epic Editor
  {
    path: '/projects/:project_id/epic/edit',
    name: 'epic_editor',
    component: () => import('./views/editors/EpicEditor.vue'),
  },
  // Not Found
  {
    name: '404',
    path: '*',
    component: () => import('./views/NotFoundComponent.vue'),
  },
];

if ( ['single'].includes(process.env.NODE_ENV) ) {
  routes.push({
    path: '/dev',
    name: 'dev_screen',
    component: () => import('./views/DevScreen.vue'),
  });
}

export default new Router({mode: 'history', routes});
